var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"lbs-uscope-toolbar-button",style:(_vm.style),attrs:{"title":_vm.title},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onClick.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }